// extracted by mini-css-extract-plugin
export default {"video-section":"r_bX d-flex","video-section--header":"r_bY","video-section__frame":"r_bZ ml-3"};